<template>
  <div class="custom-multiple">
    <el-select class="custom-multiple-more" :key="msSelectKey"
               :class="{ 'custom-multiple-more-tag': collapseTags, 'custom-multiple-more-disabled': disabled }"
               :popper-class="popperClass ? 'zwx-select-popper ' + popperClass : 'zwx-select-popper'" :ref="refVariable"
               v-model="dataValueList" placeholder="请选择" :clearable="clearable" :disabled="disabled" multiple
               :collapse-tags="collapseTags">
      <el-option v-for="item in dataList" :key="item[speed]" :label="item[value]" :value="item[speed]"/>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'CustomMultiple',
  model: {
    prop: 'selectDataValueList',
    event: 'propEvent',
  },
  props: {
    selectDataValueList: {type: Array, default: () => []},
    speed: {type: String},
    value: {type: String},
    collapseTags: {type: Boolean, default: false},
    clearable: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    popperClass: {type: String},
  },
  data() {
    return {
      refVariable: 'customMultiple' + this.$system.uuid(),
      dataList: [],
      dataValueList: this.selectDataValueList,
      msSelectKey: 100000,
    }
  },
  watch: {
    selectDataValueList(newValue) {
      this.dataValueList = newValue
    },
    dataValueList(newValue) {
      this.setElTagsWidth()
      this.$emit('propEvent', newValue)
    },
  },
  mounted() {
    this.setElTagsWidth()
  },
  methods: {
    setElTagsWidth() {
      if (!this.collapseTags) return
      this.$nextTick(() => {
        if (this.dataValueList && this.dataValueList.length > 1) {
          this.$refs[this.refVariable].$children[2].$el.style.maxWidth = `calc(100% - ${this.$refs[this.refVariable].$children[3].$el.offsetWidth}px)`
        } else {
          if (!this.$refs[this.refVariable].$children[2]) return
          this.$refs[this.refVariable].$children[2].$el.style.maxWidth = '100%'
        }
      })
    },
    setDataList(dataList) {
      this.dataList.splice(0, this.dataList.length)
      for (let i = 0, length = dataList.length; i < length; i++) {
        this.dataList.push(dataList[i])
      }
      this.msSelectKey++
      if (this.msSelectKey > 200000) this.msSelectKey = 100000
    },
    getDataList() {
      if (!this.dataValueList || this.dataValueList.length === 0) return []
      const dataSelectList = []
      for (let i = 0, length = this.dataList.length; i < length; i++) {
        for (let k = 0, len = this.dataValueList.length; k < len; k++) {
          if (this.dataList[i][this.speed] === this.dataValueList[k]) {
            dataSelectList.push(this.dataList[i])
          }
        }
      }
      return dataSelectList
    },
  },
}
</script>

<style lang="less" scoped>
.custom-multiple {
  display: inline-block !important;
}

.custom-multiple .custom-multiple-more {
  cursor: pointer !important;
}

.custom-multiple .custom-multiple-more-disabled {
  cursor: not-allowed !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-input__inner {
  width: 160px !important;
  height: auto;
  line-height: 28px !important;
  min-height: 28px !important;
  padding: 0 19px 0 6px !important;
  box-sizing: border-box !important;
  border: 1px solid #a8bbcf !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #000 !important;
  border-radius: 2px !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-input__inner:hover {
  border: 1px solid #8094a7 !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-input.is-focus .el-input__inner {
  border-color: #457dff !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-input__inner:focus {
  border: 1px solid #457dff !important;
}

.custom-multiple /deep/ .custom-multiple-more .is-disabled .el-input__inner {
  background-color: #eff2f9 !important;
  color: #646464 !important;
}

.custom-multiple /deep/ .custom-multiple-more .is-disabled .el-input__inner:hover {
  border: 1px solid #a8bbcf !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-input__suffix {
  right: 0 !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-input__icon {
  width: 22px !important;
  font-size: 8px !important;
  line-height: 28px !important;
  color: #6d87a3 !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-icon-circle-close:hover {
  color: #37608c !important;
}

.custom-multiple /deep/ .custom-multiple-more-tag .el-select__tags {
  flex-wrap: nowrap !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-tag .el-select__tags-text {
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-tag.el-tag--info.el-tag--small {
  display: flex !important;
  align-items: center !important;
  max-width: 100%;
  height: 18px !important;
  line-height: 16px !important;
  padding: 0 4px !important;
  color: #3a485e !important;
  background: rgba(168, 187, 207, 0.26) !important;
  border-radius: 2px !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-tag__close.el-icon-close {
  right: -3px !important;
  margin-top: 0 !important;
}

.custom-multiple /deep/ .custom-multiple-more .el-tag__close.el-icon-close::before {
  width: 16px !important;
  height: 16px !important;
}

.custom-multiple /deep/ .custom-multiple-more input::input-placeholder {
  color: #aaaaaa !important;
}

.custom-multiple /deep/ .custom-multiple-more input::-webkit-input-placeholder {
  color: #aaaaaa !important;
}

.custom-multiple /deep/ .custom-multiple-more input:-moz-placeholder {
  color: #aaaaaa !important;
}

.custom-multiple /deep/ .custom-multiple-more input::-moz-placeholder {
  color: #aaaaaa !important;
}

.custom-multiple /deep/ .custom-multiple-more input:-ms-input-placeholder {
  color: #aaaaaa !important;
}
</style>

<style lang="less"></style>
